import type { CurrentNetworkContext } from '../../state/types';

import type { SetNetworkContextAction } from './actions.types';

export const setNetworkContext: (networkContext: CurrentNetworkContext) => SetNetworkContextAction = (
  networkContext
) => ({
  type: 'NETWORK_CONTEXT.SET',
  payload: networkContext,
});
